var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgFriendlyBadge = function SvgFriendlyBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#7FCB7F",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#1F1F1F",
    cx: 12,
    cy: 12,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.812 6A5.811 5.811 0 006 11.812a5.811 5.811 0 005.812 5.813 5.811 5.811 0 005.813-5.813A5.811 5.811 0 0011.812 6zm1.875 3.937a.75.75 0 11.002 1.499.75.75 0 01-.002-1.499zm-3.75 0a.75.75 0 11.002 1.499.75.75 0 01-.002-1.499zm4.566 3.99a3.492 3.492 0 01-2.69 1.26 3.492 3.492 0 01-2.691-1.26c-.319-.382.258-.86.576-.48.525.63 1.294.988 2.114.988.82 0 1.59-.36 2.115-.989.314-.38.893.099.576.48z",
    fill: "#1F1F1F",
    fillRule: "nonzero"
  }))));
};

export default SvgFriendlyBadge;